export const SYNC_NOTIFICATIONS = '@@notifications/sync'

export const UPDATE_NOTIFICATIONS = '@@notifications/update'

export const SET_NEW_NOTIFICATION = '@@notifications/setNewNotification'

export const RESET_NOTIFICATION_REDUCER = '@@notifications/reset'
